var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69731 5.09082C5.29149 5.09082 4.15186 6.23046 4.15186 7.63627V20.3635C4.15186 21.7694 5.29149 22.909 6.69731 22.909H21.97C23.3759 22.909 24.5155 21.7694 24.5155 20.3635V7.63627C24.5155 6.23046 23.3759 5.09082 21.97 5.09082H6.69731ZM11.4222 18.5897C11.4222 19.152 11.878 19.6079 12.4404 19.6079C13.0027 19.6079 13.4585 19.152 13.4585 18.5897L13.4585 9.41014C13.4585 8.84781 13.0027 8.39196 12.4404 8.39196C11.878 8.39196 11.4222 8.84781 11.4222 9.41014V18.5897ZM8.62219 19.6079C8.05986 19.6079 7.604 19.152 7.604 18.5897V15.5338C7.604 14.9714 8.05986 14.5156 8.62219 14.5156C9.18451 14.5156 9.64037 14.9714 9.64037 15.5338V18.5897C9.64037 19.152 9.18451 19.6079 8.62219 19.6079ZM19.0983 18.5897C19.0983 19.152 19.5542 19.6079 20.1165 19.6079C20.6788 19.6079 21.1347 19.152 21.1347 18.5897V15.5338C21.1347 14.9714 20.6788 14.5156 20.1165 14.5156C19.5542 14.5156 19.0983 14.9714 19.0983 15.5338V18.5897ZM16.2585 19.6079C15.6962 19.6079 15.2404 19.152 15.2404 18.5897V12.3753C15.2404 11.8129 15.6962 11.3571 16.2585 11.3571C16.8209 11.3571 17.2767 11.8129 17.2767 12.3753V18.5897C17.2767 19.152 16.8209 19.6079 16.2585 19.6079Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartResult);
export default __webpack_public_path__ + "static/media/ChartResult.438fa6a629ae8e13eaf47930e3dadbba.svg";
export { ForwardRef as ReactComponent };